module.exports = __webpack_public_path__ + "static/img/icons8-microscope.c9130dc9.svg";